import React,{ useState } from 'react';
import { connect } from 'react-redux';
import '../../scss/partials/assignDevices/assignDevices.css';
import ReactPaginate from 'react-paginate';
import Button,{
    buttonTypes,
    buttonSizes,
    buttonTextSizes,
} from '../shared/Button';
import { makeConflictAssignmentRequest } from '../../redux/actions/assignDevicesActions';
import LoadingSpinner from '../shared/LoadingSpinner';

export function UnConnectedConflictAssignments(props){
    const {data,
        assignmentTriggeredFlag:conflictAssignmentTriggered,
        setAssignmentTriggeredFlag,
        apiSpinner,
        alarmDeviceTypes,
        postConflictUserConflict,
    } = props;
  
    const [conflictingArr, setConflictingArr] = useState([...data]);
    const [currentPage, setCurrentPage] = useState(0);

    const [pagerParams, setPagerParams] = useState({
        totalLength: 0,
        startValue: 0,
        endValue: 10,
        incrementValue: 10,
        totalPages:0,
        });

    const [searchFilter, setSearchFilter] = useState('');
    const handleSearchFilter = (event) => {
        const value = event.target.value;
        const pagerValues = { ...pagerParams };
        pagerValues.startValue = 0;
        setCurrentPage(0);
        setSearchFilter(value);
    };
    
    function compareType(a, b){
        return a.alarm_device_type - b.alarm_device_type;
    }

    function handlePageChange({selected}){
        const pagerValues = {...pagerParams};
        let total = pagerValues.totalLength;
        let startTemp = selected * pagerParams.incrementValue;
        let endTemp = (startTemp + pagerParams.incrementValue > total) ?
                            (total) : (startTemp + pagerParams.incrementValue);
        pagerValues.startValue = startTemp;
        pagerValues.endValue = endTemp;
        setCurrentPage(selected);
        setPagerParams(pagerValues);
    }  

    //to determine if atleast one of the checkbox is checked
    //to enable assign button
    function anyChecked(){
      let condition = conflictingArr.some((user) =>{
        return user.category.some((category)=>{
          return category.matchdevices.some((device)=> (device.checked || device.disable === true));
        });
      });
      return condition;
    }

    const [postSummaryData, setPostSummaryData] = useState({});
    const [postCategoryReference, setPostCategoryReference] = useState({});

    function handleAssign(){
      setAssignmentTriggeredFlag(true);
      // category reference to be used when post error occurs
      let categoryReference = {};
      let postDeviceAssignmentData = [];

      //iterate to get the checked devices to post
      //also store copy of the posted devices in postDeviceAssignmentData
      conflictingArr.forEach((u)=>{
        let categorytemp = [];
        let matchid = [];
        u.category.forEach((c)=>{
          let matchdevices = [];
          c.matchdevices.forEach((d) => {
            if(d.checked){
              matchid.push(d.deviceid);
              categoryReference[d.deviceid]={deviceDesc:d.deviceDesc,
                cateid:c.categoryid,cateDesc:c.cateDesc};
              matchdevices.push({deviceid:d.deviceid,deviceDesc:d.deviceDesc});
            } 
          });
          if(matchdevices.length > 0){
            categorytemp.push({cateDesc:c.cateDesc,
              matchdevices:matchdevices,matchLength:matchdevices.length});
          }
        });
        if(matchid.length > 0){
          postDeviceAssignmentData.push({user_id:u.userid,alarm_devices:matchid});
          postSummaryData[u.userid] = {
              userid:u.userid,
              firstName:u.firstName,
              lastName:u.lastName,
              activeUnit:u.activeUnit,
              category:categorytemp,
              spanLength:categorytemp.length};
        }
      });
      props.dispatch(makeConflictAssignmentRequest({data:postDeviceAssignmentData}));
      setPostSummaryData({...postSummaryData});
      setPostCategoryReference({...categoryReference});
    }

    //function to display conflicted devices returned by post
    function displayUserconflictPostConflict(){
        let tableTempData=[];
      //only get device id's from response so add device description and alarm device type 
      //using category referece arr
        postConflictUserConflict.forEach((u)=> {
          let alarm_devices = [];
          u.alarm_devices.forEach(d =>{
            alarm_devices.push({
              deviceid:d,
              deviceDesc:postCategoryReference[d].deviceDesc,
              deviceType:postCategoryReference[d].cateid})
          });
          tableTempData.push({
            userid:u.user_id,
            firstName:postSummaryData[u.user_id].firstName,
            lastName:postSummaryData[u.user_id].lastName,
            activeUnit:postSummaryData[u.user_id].activeUnit,
            alarm_devices:[...alarm_devices]
          });
        });

        let tableData = [];
        tableTempData.forEach((u)=>{
          let matchedDevices = [...u.alarm_devices];
          // sort alarm devices based on alarm device type
          matchedDevices.sort(compareType);
          let category=[];
          let devices=[];
          let type = matchedDevices[0].deviceType;
          let totalSpanLength = 0;
          //group alarm devices based on alarm device type
          for(let i=0;i<matchedDevices.length;i++){
            if(matchedDevices[i].deviceType === type){
                devices.push({deviceid:matchedDevices[i].deviceid,
                  deviceDesc:matchedDevices[i].deviceDesc})
            }
            else{
                totalSpanLength += devices.length;
                category.push({categoryid:type,cateDesc:alarmDeviceTypes[type].description,
                  matchdevices:[...devices],matchLength:devices.length});
                type = matchedDevices[i].deviceType;
                devices = [];
                devices.push({deviceid:matchedDevices[i].deviceid,
                  deviceDesc:matchedDevices[i].deviceDesc})
            } 
          }
          totalSpanLength += devices.length;
          category.push({categoryid:type,cateDesc:alarmDeviceTypes[type].description,
            matchdevices:[...devices],matchLength:devices.length});
          tableData.push({userid:u.userid,
                firstName:u.firstName,
                lastName:u.lastName,
                activeUnit:u.activeUnit,
                category:category,
                spanLength:totalSpanLength,
              });
      });

      return(
        <React.Fragment>
        <div className="width-100">
          <p className="text-medium item-container__main-text center-text">
            Error Occurred while assigning the folowing devices</p>
        </div>
        <table className="tabletag width-100" data-test="assignmentSummary-table">
          <thead>
            <tr>
              <td className="table_head_row text-bold" data-test="table-head">{"First Name"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Last Name"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Active Unit"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Category"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Device Description"}</td>
            </tr>
          </thead>
          <tbody>
          {tableData.map((each, index) =>{
            return(<React.Fragment>
              <tr data-test="table-row">
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{each.firstName}</td>
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{each.lastName}</td>
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{each.activeUnit}</td>
                <td rowSpan={each.category[0].matchLength} 
                  className={ index % 2 ? 
                  "table__row table__row--alternate align-top": 
                  "table__row align-top"}>{each.category[0].cateDesc}</td>
                <td className={ index % 2 ? 
                  "table__row table__row--alternate": 
                  "table__row"}>{each.category[0].matchdevices[0].deviceDesc}</td>
              </tr>
              {each.category[0].matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {match.deviceDesc}</td>
                  </tr>
                </React.Fragment>);
              })}
              {each.category.map((eachCatt, catindex)=>{
                if(catindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td rowSpan={eachCatt.matchLength} 
                      className={index % 2 ? 
                      "table__row table__row--alternate align-top": 
                      "table__row align-top"}>{eachCatt.cateDesc}</td>
                    <td className={index % 2 ? 
                      "table__row table__row--alternate": 
                      "table__row"}>{eachCatt.matchdevices[0].deviceDesc}</td>
                  </tr>
                  {eachCatt.matchdevices.map((match, deviceindex)=>{
                    if(deviceindex === 0)
                      return '';
                    return(<React.Fragment>
                      <tr>
                        <td className={ index % 2 ? 
                          "table__row table__row--alternate": 
                          "table__row"}>{match.deviceDesc}</td>
                      </tr>
                    </React.Fragment>);
                  })}
                </React.Fragment>);
              })}
            </React.Fragment>);
          })}
          </tbody>
        </table>
        </React.Fragment>
      );
    }

    function handleChange(id, categoryindex, deviceindex, deviceId){
      let tempArr = [...conflictingArr];
      let uindex = tempArr.map( u => u.userid ).indexOf(id);
      const clickedUserFirstName = tempArr[uindex].firstName;
      const clickedUSerLastName = tempArr[uindex].lastName;
      const clickedDeviceId = deviceId;
      const clickedUserId = tempArr[uindex].userid;
      tempArr[uindex].category[categoryindex]
          .matchdevices[deviceindex].checked = !(tempArr[uindex].category[categoryindex]
                                              .matchdevices[deviceindex].checked);
  
      tempArr.forEach((user, userindx) =>{
        if( ( user.userid !== clickedUserId ) &&
            ( user.firstName === clickedUserFirstName ) &&
            ( user.lastName === clickedUSerLastName ) ){

          user.category.forEach((category, categoryindx) => {
            category.matchdevices.forEach((device, deviceindx) =>{
                if(device.deviceid === clickedDeviceId){
                    tempArr[userindx].category[categoryindx]
                      .matchdevices[deviceindx].disable = !(tempArr[userindx].category[categoryindx]
                                                              .matchdevices[deviceindx].disable);
                }
            });
          });
        }
      });
      setConflictingArr([...tempArr]);
    }

    function displayConflictingDevicesTable(){
      let searchedDevices = [];

      if(searchFilter !== '') {
        searchedDevices = conflictingArr.filter((user) => {
        let filterResult = false;
        const searchText = searchFilter.toUpperCase();
        const userFirstName = user.firstName.toUpperCase();
        const userLastName = user.lastName.toUpperCase();
        if( userFirstName.includes(searchText) || userLastName.includes(searchText) ) {
          filterResult = true;
        }
        else{
          filterResult = user.category.some((category)=>{
            let tempResult =false;
            const categoryDescription = category.cateDesc.toUpperCase();
            if(categoryDescription.includes(searchText)){
                tempResult = true;
            }
            else{
              tempResult = category.matchdevices.some((device)=>{
                let tempResult2 = false;
                const deviceDescription = device.deviceDesc.toUpperCase();
                if(deviceDescription.includes(searchText)){
                    tempResult2 = true;
                }
                return tempResult2;
              })
            }
            return tempResult;
          })
        }
        return filterResult;
      });
      } else {
      searchedDevices = conflictingArr;
      }

      if (searchedDevices.length !== pagerParams.totalLength) {
        const pagerValues = { ...pagerParams };
        let startTemp = currentPage * pagerParams.incrementValue;
        let endTemp = (startTemp + pagerParams.incrementValue > searchedDevices.length) ?
        ( searchedDevices.length ):( startTemp + pagerParams.incrementValue);
        pagerValues.totalLength = searchedDevices.length;
        pagerValues.startValue = startTemp;
        pagerValues.endValue = endTemp;
        pagerValues.totalPages = Math.ceil(searchedDevices.length/pagerParams.incrementValue);
        setPagerParams(pagerValues);
      }

      let pagedDevices = searchedDevices.slice(pagerParams.startValue,pagerParams.endValue);

      return(
      <React.Fragment>
      <div className="flex-spread width-100">
      <div className="center-self">
          <input type="textbox" 
              data-test="searchBox"
              className="message-table__filter-search-box search_bg"
              onChange={handleSearchFilter}
              value={searchFilter}/>
      </div>
      <div className="width-15">
          <Button onClick={() => handleAssign()}
              text={"Assign"}
              buttonType={buttonTypes.secondary}
              buttonSize={buttonSizes.extraSmall}
              buttonTextSize={buttonTextSizes.mediumSmall}
              additionalStyles="no-margin width-100 justify-center"
              disabled={ !anyChecked()}/>
      </div>
      {pagerParams.totalLength > 0 ? (
      <div className="react-paginate " data-test="react-paginate">
          <ReactPaginate previousLabel={'Prev'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pagerParams.totalPages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={handlePageChange}
          activeClassName={'active'}
          forcePage={currentPage}/>
      </div>
      ) : ('')}
      </div>
      <p></p>
      <table className="tabletag width-100" data-test="conflictsAssignment-table">
      <thead>
      <tr>
        <td className="table_head_row text-bold" data-test="table-head">{"First Name"}</td>
        <td className="table_head_row text-bold" data-test="table-head">{"Last Name"}</td>
        <td className="table_head_row text-bold" data-test="table-head">{"Active Unit"}</td>
        <td className="table_head_row text-bold" data-test="table-head">{"Category"}</td>
        <td className="table_head_row text-bold" data-test="table-head">{"Device Description"}</td>
        <td className="table_head_row text-bold"></td>
      </tr>
      </thead>
      <tbody>
      {pagedDevices.map((each, index) =>{
      return(
      <React.Fragment>
        <tr data-test="table-row">
          <td rowSpan={each.spanLength} 
            className={ index % 2 ? 
              "table__row table__row--alternate align-top": 
              "table__row align-top"}>{each.firstName}</td>
          <td rowSpan={each.spanLength} 
            className={ index % 2 ? 
              "table__row table__row--alternate align-top": 
              "table__row align-top"}>{each.lastName}</td>
          <td rowSpan={each.spanLength} 
            className={ index % 2 ? 
              "table__row table__row--alternate align-top": 
              "table__row align-top"}>{each.activeUnit}</td>
          <td rowSpan={each.category[0].matchLength} 
            className={ index % 2 ? 
              "table__row table__row--alternate align-top": 
              "table__row align-top"}>{each.category[0].cateDesc}</td>
          <td className={ index % 2 ? 
            "table__row table__row--alternate": 
            "table__row"}>{each.category[0].matchdevices[0].deviceDesc}</td>
          <td className={ index % 2 ? 
            "table__row table__row--alternate": 
            "table__row"}>{
            <input type="checkbox" 
              onClick={()=>handleChange(each.userid,0,0,each.category[0].matchdevices[0].deviceid)}
              checked={each.category[0].matchdevices[0].checked}
              disabled={each.category[0].matchdevices[0].disable}></input>}
          </td>
        </tr>
        {each.category[0].matchdevices.map((match, deviceindex)=>{
          if(deviceindex === 0){
              return ''
          }
          return(
          <React.Fragment>
            <tr>
              <td className={ index % 2 ? 
                "table__row table__row--alternate": 
                "table__row"}>{match.deviceDesc}</td>
              <td className={ index % 2 ? 
                "table__row table__row--alternate": 
                "table__row"}>{
                <input type="checkbox" 
                  onClick={()=>handleChange(each.userid,0,deviceindex,match.deviceid)} 
                  checked={match.checked}
                  disabled={match.disable}></input>}
              </td>
            </tr>
          </React.Fragment>
            );})
          }
          {each.category.map((eachCatt, catindex)=>{
            if(catindex === 0){
                return ''
            }
            return(
            <React.Fragment>
              <tr>
                <td rowSpan={eachCatt.matchLength} 
                  className={index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{eachCatt.cateDesc}</td>
                <td className={index % 2 ? 
                  "table__row table__row--alternate": 
                  "table__row"}>{eachCatt.matchdevices[0].deviceDesc}</td>
                <td className={ index % 2 ? 
                  "table__row table__row--alternate": 
                  "table__row"}>{
                  <input type="checkbox" 
                    onClick={()=>handleChange(each.userid,catindex,0,eachCatt.matchdevices[0].deviceid)}
                    checked={eachCatt.matchdevices[0].checked}
                    disabled={eachCatt.matchdevices[0].disable}></input>}
                </td>
              </tr>
              {eachCatt.matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0)
                    return ''
                return(
                <React.Fragment>
                <tr>
                  <td className={ index % 2 ? 
                    "table__row table__row--alternate": "table__row"}>{match.deviceDesc}</td>
                  <td className={ index % 2 ? 
                    "table__row table__row--alternate": "table__row"}>{
                  <input type="checkbox" 
                  onClick={()=>handleChange(each.userid,catindex,deviceindex,match.deviceid)} 
                  checked={match.checked}
                  disabled={match.disable}></input>}
                  </td>
                </tr>
                </React.Fragment>
                );})
              }
            </React.Fragment>);})
          }
      </React.Fragment>);})
      }
      </tbody>
      </table>
      <div className="container_2-column margin-top-10">
        {pagerParams.totalLength > 0 ?
         (<div className="text-large placeend">
           <strong>{pagerParams.startValue+1}</strong> - 
           <strong>{pagerParams.endValue}</strong> of 
           <strong>{pagerParams.totalLength}</strong> 
           { pagerParams.totalLength > 1 ? "Categories" : "Category"}</div>):('')}
        {pagerParams.totalLength > 0 ? (
          <div className="react-paginate placeend" data-test="react-paginate">
          <ReactPaginate previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={pagerParams.totalPages}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageChange}
              activeClassName={'active'}
              forcePage={currentPage}/>
          </div>
        ) : ('')}
      </div>
    </React.Fragment>
      );
    }

    function displayTable(){
      if( !conflictAssignmentTriggered ){
        return displayConflictingDevicesTable();}
      else {
        if( apiSpinner.conflictAssignmentReturned ){
          if( postConflictUserConflict.length === 0){
            return(
              <div className="width-100">
                <p className="text-medium item-container__main-text center-text">
                  Devices Assigned successfully</p>
              </div>);
          }
          else{
            return displayUserconflictPostConflict();
          }
        }
        else{
          return (
            <div className="loading-spinner__user-list-container">
              <LoadingSpinner />
            </div>);
        }
      }
    }

    return(
    <>
    {displayTable()}
    </>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
      alarmDeviceTypes: state.assignDevices.categoryList,
      apiSpinner: state.ui.apiSpinner,
      postConflictUserConflict: state.assignDevices.postConflictUserConflictDevices
    };
};

export default connect(mapStateToProps)(UnConnectedConflictAssignments);